import { Box, Typography } from "@mui/material";
import {
  FULFILLMENT_NONE_FINISHED,
  FULFILLMENT_PARTIAL_FINISHED,
} from "../constants";
import { useTranslation } from "react-i18next";

type Props = {
  status: string | undefined;
};

export const FulfillmentStatusNotification = ({ status }: Props) => {
  const { t } = useTranslation("order");

  return (status && status === FULFILLMENT_NONE_FINISHED) ||
    status === FULFILLMENT_PARTIAL_FINISHED ? (
    <Box
      p={0.5}
      pl={4}
      m={-2}
      mb={2}
      sx={{
        backgroundColor: "#FDD835",
      }}
    >
      <Typography>
        {status === FULFILLMENT_NONE_FINISHED
          ? t("order:fulfillmentNone")
          : t("order:fulfillmentPartial")}
      </Typography>
    </Box>
  ) : null;
};
